import {Component, inject} from '@angular/core'
import {RouterOutlet} from '@angular/router'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'
import version from '../assets/package.json'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {HeaderComponent} from './components/header/header.component'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent
  ]
})
export class AppComponent {
  public version = version.version

  public configService = inject(ConfigService)
}
